require('./accountCancelChequebookSuccessStep.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const Immutable = require('immutable');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @components
const { OKButton } = require('components/commons/OKButton/OKButton');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

class AccountCancelChequebookSuccessStep extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentWillUnmount() {
        const { accountId } = this.props;
        this.props.requestCheques(accountId);
    }

    render() {
        const { immAccountsCheques, accountId } = this.props;
        const immCheques = immAccountsCheques.get(accountId);
        const { chequebookIndex } = this.props;
        const number = immCheques.get('byOrder').get(chequebookIndex);
        const immCheque = !__CONTACT_CENTER__
                          ? immCheques.get('byId').get(number)
                          : immCheques.getIn([ 'byId', number ], new Immutable.Map());
        const checkFrom = immCheque.get('initialNum');
        const checkTo = immCheque.get('finalNum');
        const title = formatText('accountCancelChequebook-successStepTitle', [checkFrom, checkTo]);

        return (
            <WizardSuccess
                successMessage={title}
            >
                <footer className="account-cancel-chequebook-success__footer">
                    <OKButton modifier="link-complementary pull-right" onClick={this.props.handleGoBack}>
                        <FormattedText value="accountCancelChequebook-successStepBackLink" />
                    </OKButton>
                </footer>
            </WizardSuccess>
        );

        /*
        return (
            <article className="account-cancel-chequebook-success">
                <header className="account-cancel-chequebook-success__header">
                    <FormattedText
                        value="accountCancelChequebook-successStepTitle"
                        className="account-cancel-chequebook-success__title"
                    />
                </header>
                <section className="account-cancel-chequebook-success__content">
                    <div className="account-cancel-chequebook-success__row">

                    </div>
                </section>
                <footer>
                    <OKButton modifier="link-complementary" onClick={this.props.handleGoBack}>
                        <FormattedText value="accountCancelChequebook-successStepBackLink" />
                    </OKButton>
                </footer>
            </article>
        );*/
    }
}

AccountCancelChequebookSuccessStep.propTypes = {
    immAccountsCheques: PropTypes.object.isRequired,
    requestCheques: PropTypes.func.isRequired,
    accountId: PropTypes.string.isRequired,
    chequebookIndex: PropTypes.string.isRequired,
    handleGoBack: PropTypes.func
};

module.exports = AccountCancelChequebookSuccessStep;
